import { observer } from "mobx-react-lite";
import { useTran } from "@/hooks";
import AppDialog from "@/components/common/AppDialog";
import { useActivityLogStore } from "../hooks";

const ActivityLogDetailsDialog = observer(() => {
  const { t } = useTran();
  const { detailsOpen, detailsText, closeDetails } = useActivityLogStore();

  return (
    <AppDialog
      open={detailsOpen}
      onOpenChange={(open) => {
        if (!open) closeDetails();
      }}
      title={t("Details")}
      size="lg"
      bodyClassName="max-h-[70vh]"
    >
      <pre className="whitespace-pre-wrap text-sm text-muted-foreground">
        {detailsText}
      </pre>
    </AppDialog>
  );
});

export default ActivityLogDetailsDialog;
